<template>
  <div>
    <toolbar/>
    <main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </main>
  </div>
</template>
<script>
import Toolbar from '@/website/components/Toolbar'

export default {
  data () {
    return { show: false }
  },
  components: {
    Toolbar
  },
}
</script>
